export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10539.bb225390.jpg";